/** Idempotency keys for order/close submissions (double-click / retry safe). */
export const newIdempotencyKey = (): string =>
  typeof crypto !== "undefined" && "randomUUID" in crypto
    ? crypto.randomUUID().replace(/-/g, "")
    : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;
